import type { Money } from '~/utils/money'

const MILLION = 1_000_000
const BILLION = 1_000_000_000

export const usePrizeMoneyFormatter = () => {
  const { t } = useI18nUtils()

  const formatPrizeMoney = (amount: Money | null | undefined): string => {
    if (!amount) return ''

    const normalized = normalizeMoney(amount)

    const formatLargeAmount = (divisor: number, key: string) => {
      const value = parseFloat((normalized / divisor).toFixed(2))
      const prize = new Intl.NumberFormat('en-US', {
        currency: amount.currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
        style: 'currency',
      }).format(value)
      return `${prize} ${t(key, value)}`
    }

    if (normalized >= BILLION) return formatLargeAmount(BILLION, 'common.words.billion')
    if (normalized >= MILLION) return formatLargeAmount(MILLION, 'common.words.million')

    return formatMoney(amount, { fractionDigits: normalized % 1 === 0 ? 0 : 2 })
  }

  return { formatPrizeMoney }
}
